import { AxiosInstance } from 'axios';
import { store } from '../../store';
import { authApiService } from '../../modules/auth/services/api';
import {
  authClearAction,
  postLoginSuccessApiAction,
} from '../../modules/auth/store/reducer';
import { User } from '../../interfaces/user.interface';

export const refreshTokenInterceptor = (
  instance: AxiosInstance,
  refreshToken: string | null,
  user: User
) =>
  async function (error: any) {
    try {
      const originalRequest = error.config;
      if (
        error.response &&
        error.response.status === 401 &&
        !originalRequest.url.includes('auth/login')
      )
        if (!originalRequest._retry) {
          originalRequest._retry = true;

          const response = await authApiService.postRefresh({
            email: user.email,
            refresh_token: refreshToken!,
          });

          store.dispatch(postLoginSuccessApiAction(response));

          originalRequest.headers = {
            ...originalRequest.headers,
            Authorization: `Bearer ${response.token}`,
          };
          return instance(originalRequest);
        } else {
          store.dispatch(authClearAction());
        }
    } catch (e) {
      console.error('Error Refreshing Token', e);
      store.dispatch(authClearAction());
    }
    return Promise.reject(error);
  };
